

var _newMember = require('xo-models/src/newMember');

define(['angular', 'squid/index', '../login/kmliEligibility'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-unified-login.kmliUpsell', ['squid']).factory('$KmliUpsell', function ($pxp, $populate, $rootScope, $CheckoutAppDataModel, $CheckoutCartModel, $AuthModel, $DeviceInfo, $feature, $KmliEligibility, $config, $logger, $util, $q) {

        // Model Retrived
        var idToken, successfulLogin, isOneTouched, upsellOptInDisplayed, kmliEligible, ulAsLanding, walletTokenization, preloadUL, lastUpsellVersion; // eslint-disable-line no-unused-vars
        var showReactivationInterstitial, kmliChecked; // Passed in init
        var expPromise; // Promisified experience data
        var scope = {};

        var getKmliContentKey = function getKmliContentKey() {
            var kmliContentMapping = {
                xo_hermesnode_kmli_content_control: '0', // disabled [Do Not Use] - ul has conflicts
                xo_hermesnode_kmli_content_t1: '1', // Current content
                xo_hermesnode_kmli_content_t2: '2', // disabled [Do Not Use] - ul has conflicts
                xo_hermesnode_kmli_content_t3: '3' // Auto Login for faster checkout
            };

            var country = scope.checkoutAppData.merchant.merchant_country;
            return $pxp($config.ulMeta.kmliContentExpId, { 'ctx.COUNTRY': country }, 'xo_hermesnode_kmli_content_.*').then(function (result) {
                var contentKey = result && result.treatment_name;
                scope.oneTouchContentVersion = contentKey && kmliContentMapping[contentKey];
                $logger.debug('kmliUpsell_getKmliContentKey_' + scope.oneTouchContentVersion);
            });
        };

        // Determine if the NMJ experience the user has is ineligible
        var getNewMemberVariant = function getNewMemberVariant() {
            return _newMember.$NewMemberEligibility.instance().getVariant(scope.token).then(function (variant) {
                scope.isNmj = variant && (variant === 'one_page' || variant === 'multi_page');
                $logger.debug('kmliUpsell_getNewMemberVariant');
            })['catch'](function (err) {
                return $logger.debug('getNewMemberVariant_err', {
                    error: err
                });
            });
        };

        var resolveEligibilityConditions = function resolveEligibilityConditions(params) {
            idToken = Boolean(scope.auth.idTokenPresent);
            successfulLogin = scope.auth.loggedIn();
            isOneTouched = scope.auth.loggedIn() && scope.auth.refreshToken();
            walletTokenization = scope.checkoutCart.isWalletTokenization() || scope.auth.remembered_partner_assertion; // android pay, apple pay, etc
            kmliChecked = Boolean(params.isKmliSet); // may not be OT but user has already opted in
            upsellOptInDisplayed = Boolean(scope.auth.upsellOptInDisplayed);
            lastUpsellVersion = scope.auth.ryiOptIn && scope.auth.ryiOptIn.interstitialDisplayed;
            showReactivationInterstitial = Boolean(params.showReactivationInterstitial);
            $logger.debug('kmliUpsell_resolveEligibilityConditions', {
                params: params
            });
            if (walletTokenization || preloadUL || scope.oneTouchContentVersion !== '3') {
                // do not trigger pxp for walletTokenization, ulpreload
                // Interstitial is only eligibile when the contentKey is set to treatment 3
                $logger.debug('kmliUpsell_init_ineligible');
                return $q.resolve();
            }
            return $pxp('xo_hermesnode_kmli_upsell', {
                'ctx.COUNTRY': scope.auth.buyer_ipcountry
            }, 'xo_hermes_kmli_upsell_(web|mobile)_v2_treatment.*');
        };

        var getExperienceFromPxp = function getExperienceFromPxp(pxpRes) {
            var experience = pxpRes ? { name: pxpRes.treatment_name } : '';
            lastUpsellVersion = lastUpsellVersion ? lastUpsellVersion : upsellOptInDisplayed ? 0.1 : 0.0; // eslint-disable-line no-nested-ternary
            // for lastUpsellVersion use 0.1 when poma and not ryi case else use 0
            if (pxpRes && pxpRes.factors) {
                var factors = pxpRes.factors.reduce(function (out, factor) {
                    out[factor.name] = factor.value;
                    return out;
                }, {});
                experience.version = +factors.version > +lastUpsellVersion;
                experience.color = factors.color;
                experience.pxpVersion = factors.version;
            }
            $logger.debug('kmliUpsell_getExperienceFromPxp', {
                experience: experience
            });
            return experience;
        };

        return {

            init: function init(params) {
                scope.token = $rootScope.token;

                if (expPromise) {
                    return; // do not init twice
                }
                $logger.debug('kmliUpsell_init', params);
                expPromise = $KmliEligibility.init().then(function (KmliEligibility) {
                    kmliEligible = Boolean(KmliEligibility.kmliEligibility) && !params.jwtBasedAssertion;
                    ulAsLanding = Boolean(KmliEligibility.ulAsLanding);
                    preloadUL = Boolean(KmliEligibility.preloadUL);
                    return $populate(scope, {
                        auth: $AuthModel.instance(),
                        checkoutCart: $CheckoutCartModel.instance(scope.token),
                        checkoutAppData: $CheckoutAppDataModel.instance(scope.token)
                    });
                }).then(getKmliContentKey).then(function () {
                    return resolveEligibilityConditions(params);
                }).then(function (pxpRes) {
                    return getExperienceFromPxp(pxpRes);
                });
            },

            // This should be called after checkout session is populated
            // Any data depending on the checkout session should be resolved here
            eligible: function eligible() {
                var eligibility = {};
                if (!expPromise) {
                    $logger.debug('kmliUpsell_init_not_executed');
                    return $q.resolve(eligibility);
                }
                return $q.all([expPromise, getNewMemberVariant()]).then(function (result) {
                    var experience = result[0];
                    var eligibilityCriteria = {
                        pxp: experience,
                        profile_country: $feature('ryiOptIn'),
                        isNotNmj: !scope.isNmj
                    };
                    $logger.debug('kmliUpsell_eligiblityCheck', {
                        eligibilityCriteria: eligibilityCriteria
                    });
                    var ineligibleReasons = $util.filter(Object.keys(eligibilityCriteria), function (key) {
                        return !eligibilityCriteria[key];
                    });
                    var upsellFeatureEnabled = ineligibleReasons.length === 0;
                    var regularLogin = kmliEligible && idToken;
                    var autoLoginEnabled = isOneTouched || kmliChecked || scope.auth.remembered;

                    eligibility.banner = upsellFeatureEnabled && $feature('optinToggle') && Boolean(isOneTouched || regularLogin);

                    eligibility.interstitial = {
                        eligible: upsellFeatureEnabled && !autoLoginEnabled && experience && experience.name && (experience.name.slice(-1) === '1' || experience.name.slice(-1) === '3') // use only treatment 1,3 for interstitial
                        && experience.version,
                        type: showReactivationInterstitial ? 'reactivation' : successfulLogin ? 'member' : '', // eslint-disable-line no-nested-ternary
                        color: experience && experience.color,
                        pxpVersion: experience && experience.pxpVersion
                    };

                    var elgStr = 'interstitial-' + eligibility.interstitial.eligible + '&toggle-';

                    $logger.info('ryi_optin', {
                        'from': 'ryi_optin_elg_chk',
                        'to': 'process_ryi_optin_elg_chk',
                        'eligibility_reason': upsellFeatureEnabled ? elgStr + 'eligible' : elgStr + 'ineligible_' + ineligibleReasons.join()
                    });
                    $logger.debug('kmliUpsell_eligibility', {
                        eligibility: eligibility,
                        experience: experience,
                        cases: {
                            activeOT: isOneTouched,
                            regularLogin: regularLogin,
                            feature: upsellFeatureEnabled
                        }
                    });
                    return eligibility;
                });
            },

            getOptions: function getOptions() {

                if (showReactivationInterstitial) {
                    return {
                        flowName: 'expiredUpsell'
                    };
                }
            },

            getFPTIAttributes: function getFPTIAttributes() {

                if (showReactivationInterstitial) {
                    return {
                        stateName: 'KMLI_reactivation',
                        transInfix: '_kmli_reactivation_'
                    };
                } else {
                    return {
                        stateName: 'KMLI_UPSELL',
                        transInfix: '_kmli_upsell_'
                    };
                }
            }
        };
    });
});

_newMember.$NewMemberEligibility;


//////////////////
// WEBPACK FOOTER
// ./components/xo-login-components/src/onetouch-interstitial/kmliUpsell.js
// module id = ./components/xo-login-components/src/onetouch-interstitial/kmliUpsell.js
// module chunks = 1